import PropTypes from "prop-types"
import { InputAdornment, TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { NumericFormat } from "react-number-format"
import { ACCOUNT_GROUP_TYPE, AccountGroupPropTypes, AccountSubgroupPropTypes, formatInputValuesToDefault } from "../../../../utils/financialHelper"
import CrudFormPage from "../../../../components/Financial/CrudFormPage"
import SelectGrupoContabil from "../../../../components/Financial/SelectGrupoContabil"
import SelectSubgrupoContabil from "../../../../components/Financial/SelectSubgrupoContabil"

const FormTiposImposto = ({ values, setValues, isDelete: isDisabled, isLoadingSubmit = false }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: formatInputValuesToDefault(value) });
  }

  const esfera = ['Federal', 'Estadual', 'Municipal']

  return (
    <CrudFormPage isLoadingSubmit={isLoadingSubmit}>
      <div className='linha-campos'>
        <TextField
          label="Sigla"
          id='code'
          name='code'
          value={values.code ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          required
          fullWidth
          disabled={isDisabled}
        />
        <TextField
          label="Nome"
          id='name'
          name='name'
          value={values.name ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          required
          fullWidth
          disabled={isDisabled}
        />
      </div>

      <div className='linha-campos'>
        <Autocomplete
          id="type"
          options={esfera}
          value={esfera.find(option => option === values.type) ?? null}
          renderInput={(params) =>
            <TextField {...params} label="Esfera" variant="outlined" InputLabelProps={{ shrink: true }} required />
          }
          onChange={(e, newValue) => setValues({ ...values, type: newValue })}
          fullWidth
          disabled={isDisabled}
        />
        <NumericFormat
          customInput={TextField}
          label="Taxa Padrão"
          id='standardRate'
          name='standardRate'
          value={values.standardRate ?? ''}
          variant="outlined"
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
          InputLabelProps={{ shrink: true }}
          fullWidth
          disabled={isDisabled}
          decimalSeparator=","
          decimalScale={2}
          autoComplete="off"
          onChange={handleChange}
          required
        />
      </div>

      <div className='linha-campos'>
        <SelectGrupoContabil
          setValues={setValues}
          accountGroup={values.accountGroup ?? null}
          isDelete={isDisabled}
          type={ACCOUNT_GROUP_TYPE.OUTCOME}
          isRequired={false}
        />
        <SelectSubgrupoContabil
          setValues={setValues}
          accountGroup={values.accountGroup ?? null}
          accountSubgroup={values.accountSubgroup ?? null}
          isDelete={isDisabled}
          isRequired={false}
        />
      </div>

      <div className='linha-campos'>
        <TextField
          label="Base de Cálculo"
          id='calculationBase'
          name='calculationBase'
          value={values.calculationBase ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
      </div>
    </CrudFormPage>
  )
}

FormTiposImposto.propTypes = {
  values: PropTypes.shape({
    id: PropTypes.number.isRequired,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOfType([
      PropTypes.oneOf(['Federal', 'Estadual', 'Municipal']),
      PropTypes.oneOf([null]),
    ]),
    standardRate: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.oneOf([null]),
    ]),
    calculationBase: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.oneOf([null]),
    ]),
    createdAt: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.oneOf([null]),
    ]),
    updatedAt: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.oneOf([null]),
    ]),
    accountGroupId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.oneOf([null]),
    ]),
    accountSubgroupId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.oneOf([null]),
    ]),
    accountGroup: PropTypes.oneOfType([
      PropTypes.shape(AccountGroupPropTypes),
      PropTypes.oneOf([null]),
    ]),
    accountSubgroup: PropTypes.oneOfType([
      PropTypes.shape(AccountSubgroupPropTypes),
      PropTypes.oneOf([null]),
    ]),
  }).isRequired,
  setValues: PropTypes.func.isRequired,
  isDelete: PropTypes.bool.isRequired,
  isLoadingSubmit: PropTypes.bool.isRequired,
}

export default FormTiposImposto